import { Tooltip } from '@creditsights/styleguide-web';
import React from 'react';
import classNames from 'classnames/bind';
import { NOT_AVAILABLE } from '../../widgets/RiskSummary/RiskSummary.logic';
import styles from './ScoreLine.module.scss';

const cx = classNames.bind(styles);

interface ScoreLineProps {
  steps: string[];
  activeStep: string;
  title: string;
  tooltip: string;
  dataTestId: string;
}

const ScoreLine = ({ steps, activeStep, title, tooltip, dataTestId }: ScoreLineProps): React.ReactElement => {
  const fields: JSX.Element[] = steps.map((step) => (
    <div key={step} className={cx('step', { active: step === activeStep })} />
  ));

  return (
    <Tooltip content={tooltip}>
      <div className={cx('body')} data-testid={dataTestId}>
        <div className={cx('title')}>{title}</div>
        <div className={cx('bar', { empty: activeStep === NOT_AVAILABLE || activeStep === '' })} />
        <div className={cx('steps')}>{fields}</div>
        <div className={cx('step-label')}>{activeStep}</div>
      </div>
    </Tooltip>
  );
};

export default ScoreLine;
